import Sphere from "../Sphere"
import styles from "./Banner.module.css"
import sharie_logo from "../../../assets/images/shariehandslogo.png"
import { Typography } from "@mui/material"

function Banner() {
  return (
    <div className={styles.banner}>
      <div className={styles.banner_content}>
        {/* <Typography sx={{ marginTop: "5rem" }} variant='h1' color={"primary"}>
          Sharie
        </Typography> */}
        <Sphere image={sharie_logo} size={15} />
      </div>
    </div>
  )
}

export default Banner
